

import { cartesians2lonlats } from "./geojson"


//计算地表投影平面面积，单位：平方米
export function getArea(positions, noAdd) {
    var coordinates = cartesians2lonlats(positions);
    if (!noAdd && coordinates.length > 0) coordinates.push(coordinates[0]);

    //API: http://turfjs.org/docs/#area
    var area = window.turf.area({
        type: "Feature",
        geometry: {
            type: "Polygon",
            coordinates: [coordinates]
        }
    });
    return area;
}
//格式化 数字 小数位数
export function formatNum(num, digits) {
    return Number(num.toFixed(digits || 0));
}


//  计算面积后，格式化显示面积值, 可指定单位
//  unit支持:m、km、mu、ha   默认自动判断 m 或 km
export function formatArea(val, unit) {
    if (val == null) return "";

    if (unit == null || unit == "auto") {
        if (val < 1000000) unit = "m"; else unit = "km";
    }

    var valstr = "";
    switch (unit) {
        default:
        case "m":
            valstr = val.toFixed(2) + '平方米';
            break;
        case "km":
            valstr = (val / 1000000).toFixed(2) + '平方公里';
            break;
        case "mu":
            valstr = (val * 0.0015).toFixed(2) + '亩';
            break;
        case "ha":
            valstr = (val * 0.0001).toFixed(2) + '公顷';
            break;
    }

    return valstr;
}

//格式化经度/纬度，返回度分秒字符串
export function formatDegree(value) {
    var s = value < 0 ? '-' : '';
    value = Math.abs(value);
    var v1 = Math.floor(value); //度  
    var v2 = Math.floor((value - v1) * 60); //分  
    var v3 = Math.round((value - v1) * 3600 % 60); //秒  
    return s + v1 + '° ' + v2 + '\'  ' + v3 + '"';
};